import type { CardCorners } from 'blocks/Cards/Card.h'

import { styled } from '@linaria/react'
import { COLOR } from 'vars/index'

export const PosterSC = styled.img<{
  withBackground?: boolean
  rounded?: boolean
  backgroundColor: COLOR
  corners?: CardCorners
  show?: boolean
}>`
  background: ${({ backgroundColor, withBackground }) =>
    withBackground ? `var(${backgroundColor})` : 'none'};
  padding: ${({ withBackground }) => (withBackground ? '11px' : 0)};
  border-radius: ${({ rounded, corners }) =>
    rounded ? '50%' : corners ? `var(${corners})` : 0};
  opacity: ${({ show }) => (show ? 1 : 0)};
  transition: opacity 0.3s;
`

export const PosterPlaceholderSC = styled.div<{
  show?: boolean
}>`
  width: '100%';
  height: '100%';
  background: var(${COLOR.TEXT_ICON_CONSTANT_DARK});
  opacity: ${({ show }) => (show ? 1 : 0)};
`
